<template>
  <div class="page-break">
    <el-row>
      <el-col v-if="topData.length > 0" :span="13" style="margin-top:5px;">
        <ul>
          <li style="font-size: 27px;font-weight:600;margin-bottom:3px;white-space: nowrap; /* 因为设置了block，所以需要设置nowrap来确保不换行
      overflow: hidden; /* 超出隐藏结合width使用截取采用效果*/
      text-overflow: ellipsis; /* 本功能的主要功臣，超出部分的剪裁方式 */
      -o-text-overflow: ellipsis; /* 特定浏览器前缀 */
      text-decoration: none;">{{ topData[0].SUPPLIER_NAME }}</li>
          <li>项&nbsp;&nbsp;目&nbsp;&nbsp;点：{{ topData[0].PROJECT_NAME }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期：{{ topData[0].SEND_DAY }}</li>
        </ul>
      </el-col>
      <el-col :span="11" style="padding-left: 15px;margin-top:5px;">
        <ul>
          <li style="font-size: 27px;font-weight:600;margin-bottom:3px;margin-left:180px;">
            [日&nbsp;订&nbsp;单]
          </li>
          <li>制&nbsp;&nbsp;单&nbsp;&nbsp;人：{{ managername }}<span
              style="margin-left: 110px;font-size: 20px;">第{{ mainData[0].currentPage }}页/共{{ mainData[0].totalPage }}页</span>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22" style="position:relative;">
        <table style="width: 100%">
          <tr class="aa">
            <th style="width: 5%">序号</th>
            <th style="width: 30%">名称</th>
            <th style="width: 5%">单位</th>
            <th style="width: 8%">订购</th>
            <th style="width: 10%">实收</th>
            <!--            printRealFlag 带不带实收-->
            <th v-if="topData[0].SHOW_PRICE == 1" style="width: 8%">价格</th>
            <th v-if="topData[0].SHOW_PRICE == 1 && printRealFlag == 1" style="width: 8%">总金额</th>
            <th v-if="topData[0].SHOW_PRICE == 1 && printRealFlag == 0" style="width: 8%">总金额</th>
          </tr>
          <tr v-for="(item, index) in mainData[0]" :key="index">
            <td>{{ item.ID }}</td>
            <td>{{ item.PRODUCT_NAME }}</td>
            <td>{{ item.TYPE_UNIT }}</td>
            <td>{{ item.PRODUCT_COUNT }}</td>
            <td v-if="printRealFlag == 1">{{ item.REAL_COUNT }}</td>
            <td v-if="printRealFlag == 0"></td>
            <td v-if="topData[0].SHOW_PRICE == 1">{{ item.PROJECT_PRICE }}
            </td>
            <td v-if="topData[0].SHOW_PRICE == 1  && printRealFlag == 1">
              {{ Math.round((item.REAL_COUNT * item.PROJECT_PRICE) * 100) / 100 }}
            </td>
            <!--            printRealFlag 为0 不打印实收 总金额为 PRODUCT_COUNT * PROJECT_PRICE-->
            <td v-if="topData[0].SHOW_PRICE == 1  && printRealFlag == 0">
              {{ Math.round((item.PRODUCT_COUNT * item.PROJECT_PRICE) * 100) / 100 }}
            </td>
          </tr>
        </table>
      </el-col>
      <div style=" position:absolute;right:6%;display:flex;flex-direction: column;font-size:0;">
        <span style="font-size:15px">白</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">存</span>
        <span style="font-size:15px">根</span>
        <div style="height:5px;"> </div>
        <span style="font-size:15px">红</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">客</span>
        <span style="font-size:15px">户</span>
        <div style="height:5px;"></div>
        <span style="font-size:15px">蓝</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">回</span>
        <span style="font-size:15px">单</span>
        <div style="height:5px;"> </div>
        <span style="font-size:15px">黄</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">发</span>
        <span style="font-size:15px">货</span>
      </div>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="5">
        <span>收货时间：</span>
      </el-col>
      <el-col :span="6">
        <span v-if="topData[0].SHOW_PRICE == 1">本页金额：{{ mainData[0].pageFee }}</span>
      </el-col>
      <el-col :span="6">
        <span v-if="topData[0].SHOW_PRICE == 1  && printRealFlag == 0">总金额：{{ project_total_fee }}</span>
      </el-col>
      <el-col :span="6">
        <span v-if="topData[0].SHOW_PRICE == 1 && printRealFlag == 1">总金额：{{ tatal_project_real_fee }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="5">
        <span>送货员：</span>
      </el-col>
      <el-col :span="5">
        <span>项目经理：</span>
      </el-col>
      <el-col :span="6">
        <span>厨师长：</span>
      </el-col>
      <el-col :span="6">
        <span>验收人员：</span>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    isRemarks: {
      type: Number,
      default() {
        return 1;
      },
      required: true,
    },
    manager: String,
    supplier: String,
    PROJECT_TOTAL_FEE: Number,
    TOTAL_PROJECT_NEED_PRICE: Number,
    TOTAL_PROJECT_REAL_FEE: Number,
  },
  data() {
    return {
      topData: [],
      managername: '',
      mainData: [],
      supplier_name: '',
      printProject: '',
      PRINT_PROJECT_NAME: '',
      printRealFlag: Number(sessionStorage.getItem('PRINT_REAL_COUNT')), // 实收 0 不带 1 带
      project_total_fee: 0,
      tatal_project_real_fee: 0,
    };
  },
  created() {
    this.managername = this.manager;
    this.topData = this.headerData;
    this.mainData.push(this.tableData);
    this.printSupplier = this.supplier;
    this.project_total_fee = this.PROJECT_TOTAL_FEE ? this.PROJECT_TOTAL_FEE.toFixed(2) : 0;
    this.tatal_project_real_fee = this.TOTAL_PROJECT_REAL_FEE ? this.TOTAL_PROJECT_REAL_FEE.toFixed(2) : 0;
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}
li {
  list-style: none;
  font-size: 20px;
  line-height: 20px;
  color: #000;
  font-family: 黑体;
}
span {
  font-size: 20px;
  line-height: 20px;
  color: #000;
  font-family: 黑体;
}

table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
}

td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 20px;
  height: 20px;
  font-family: 黑体;
  color: #000;
  /* white-space:nowrap;overflow:hidden;text-overflow:ellipsis; */
  white-space: nowrap;
  /* 因为设置了block，所以需要设置nowrap来确保不换行
      overflow: hidden; /* 超出隐藏结合width使用截取采用效果*/
  text-overflow: ellipsis;
  /* 本功能的主要功臣，超出部分的剪裁方式 */
  -o-text-overflow: ellipsis;
  /* 特定浏览器前缀 */
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/dailyOrderShortTax.vue